export const hash = 'bb470449-b095-41ab-857f-60cee9dbe096';

// export const gateKey = '';
export const gateKey = 'ek_live_g5Df6bp6y5ptAKeOVOpBloZHmqY0sb';
export const recaptchaKey = '6Ld9r7cZAAAAABw5wijiLD5PhlWqLivIN9NqFKi_';
export const apiUrl = `https://api-global-v3.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://socket-2023.encontrodigital.com.br';



//export const apiSocket = 'http://localhost:8080';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const websitePath = 'https://45-semana-cientifica-hcpa.encontrodigital.com.br';
export const urlWebsite = 'https://45-semana-cientifica-hcpa.encontrodigital.com.br';
export const supportNumber = `555195181533`;
export const home = 'Home';
export const haveTranslate = false;
export const defaultProjectHash = 'Semana Científica do HCPA';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = 'Semana Científica do HCPA';
export const logo = '/assets/logo4.png';
export const background = '/assets/Fundo.jpg';
export const authTitle = 'Semana Científica do HCPA';
export const dadosOrganizacao = '';
export const social = {
    whatsapp: '',
    instagram: '',
    facebook: '',
    linkedin: '',
    youtube: '',
    spotify: '',
    twitter: '',
    website: '',
};


export const defaultTheme = {
    defaultBackground: '#1E9D90',
    defaultColor: '#fff',
    logo: {
        minWidth: '450px',
    },
    menu: {
        background: '#1E9D90',
        backgroundSticky: '#1E9D90',
        backgroundMobile: '#1E9D90',
        color: '#fff',
        shadow: '0',
        logoColor: 'none',
    },
};

export const getToken = (): string | null => {
    const token = localStorage.getItem(`@${authTitle}:token`);
    return token;
};
